export const city = [{
		"code": "420000",
		"name": "湖北省",
		"cityList": [{
				"code": "420100",
				"name": "武汉市",
				"areaList": [{
						"code": "420102",
						"name": "江岸区"
					},
					{
						"code": "420103",
						"name": "江汉区"
					},
					{
						"code": "420104",
						"name": "硚口区"
					},
					{
						"code": "420105",
						"name": "汉阳区"
					},
					{
						"code": "420106",
						"name": "武昌区"
					},
					{
						"code": "420107",
						"name": "青山区"
					},
					{
						"code": "420111",
						"name": "洪山区"
					},
					{
						"code": "420112",
						"name": "东西湖区"
					},
					{
						"code": "420113",
						"name": "汉南区"
					},
					{
						"code": "420114",
						"name": "蔡甸区"
					},
					{
						"code": "420115",
						"name": "江夏区"
					},
					{
						"code": "420116",
						"name": "黄陂区"
					},
					{
						"code": "420117",
						"name": "新洲区"
					}

				]

			},
			{
				"code": "420200",
				"name": "黄石市",
				"areaList": [{
						"code": "420202",
						"name": "黄石港区"
					},
					{
						"code": "420203",
						"name": "西塞山区"
					},
					{
						"code": "420204",
						"name": "下陆区"
					},
					{
						"code": "420205",
						"name": "铁山区"
					},
					{
						"code": "420222",
						"name": "阳新县"
					},
					{
						"code": "420281",
						"name": "大冶市"
					}

				]

			},
			{
				"code": "420300",
				"name": "十堰市",
				"areaList": [{
						"code": "420302",
						"name": "茅箭区"
					},
					{
						"code": "420303",
						"name": "张湾区"
					},
					{
						"code": "420304",
						"name": "郧阳区"
					},
					{
						"code": "420322",
						"name": "郧西县"
					},
					{
						"code": "420323",
						"name": "竹山县"
					},
					{
						"code": "420324",
						"name": "竹溪县"
					},
					{
						"code": "420325",
						"name": "房县"
					},
					{
						"code": "420381",
						"name": "丹江口市"
					}

				]

			},
			{
				"code": "420500",
				"name": "宜昌市",
				"areaList": [{
						"code": "420502",
						"name": "西陵区"
					},
					{
						"code": "420503",
						"name": "伍家岗区"
					},
					{
						"code": "420504",
						"name": "点军区"
					},
					{
						"code": "420505",
						"name": "猇亭区"
					},
					{
						"code": "420506",
						"name": "夷陵区"
					},
					{
						"code": "420525",
						"name": "远安县"
					},
					{
						"code": "420526",
						"name": "兴山县"
					},
					{
						"code": "420527",
						"name": "秭归县"
					},
					{
						"code": "420528",
						"name": "长阳土家族自治县"
					},
					{
						"code": "420529",
						"name": "五峰土家族自治县"
					},
					{
						"code": "420581",
						"name": "宜都市"
					},
					{
						"code": "420582",
						"name": "当阳市"
					},
					{
						"code": "420583",
						"name": "枝江市"
					}

				]

			},
			{
				"code": "420600",
				"name": "襄阳市",
				"areaList": [{
						"code": "420602",
						"name": "襄城区"
					},
					{
						"code": "420606",
						"name": "樊城区"
					},
					{
						"code": "420607",
						"name": "襄州区"
					},
					{
						"code": "420624",
						"name": "南漳县"
					},
					{
						"code": "420625",
						"name": "谷城县"
					},
					{
						"code": "420626",
						"name": "保康县"
					},
					{
						"code": "420682",
						"name": "老河口市"
					},
					{
						"code": "420683",
						"name": "枣阳市"
					},
					{
						"code": "420684",
						"name": "宜城市"
					}

				]

			},
			{
				"code": "420700",
				"name": "鄂州市",
				"areaList": [{
						"code": "420702",
						"name": "梁子湖区"
					},
					{
						"code": "420703",
						"name": "华容区"
					},
					{
						"code": "420704",
						"name": "鄂城区"
					}

				]

			},
			{
				"code": "420800",
				"name": "荆门市",
				"areaList": [{
						"code": "420802",
						"name": "东宝区"
					},
					{
						"code": "420804",
						"name": "掇刀区"
					},
					{
						"code": "420821",
						"name": "京山县"
					},
					{
						"code": "420822",
						"name": "沙洋县"
					},
					{
						"code": "420881",
						"name": "钟祥市"
					}

				]

			},
			{
				"code": "420900",
				"name": "孝感市",
				"areaList": [{
						"code": "420902",
						"name": "孝南区"
					},
					{
						"code": "420921",
						"name": "孝昌县"
					},
					{
						"code": "420922",
						"name": "大悟县"
					},
					{
						"code": "420923",
						"name": "云梦县"
					},
					{
						"code": "420981",
						"name": "应城市"
					},
					{
						"code": "420982",
						"name": "安陆市"
					},
					{
						"code": "420984",
						"name": "汉川市"
					}

				]

			},
			{
				"code": "421000",
				"name": "荆州市",
				"areaList": [{
						"code": "421002",
						"name": "沙市区"
					},
					{
						"code": "421003",
						"name": "荆州区"
					},
					{
						"code": "421022",
						"name": "公安县"
					},
					{
						"code": "421023",
						"name": "监利县"
					},
					{
						"code": "421024",
						"name": "江陵县"
					},
					{
						"code": "421081",
						"name": "石首市"
					},
					{
						"code": "421083",
						"name": "洪湖市"
					},
					{
						"code": "421087",
						"name": "松滋市"
					}

				]

			},
			{
				"code": "421100",
				"name": "黄冈市",
				"areaList": [{
						"code": "421102",
						"name": "黄州区"
					},
					{
						"code": "421121",
						"name": "团风县"
					},
					{
						"code": "421122",
						"name": "红安县"
					},
					{
						"code": "421123",
						"name": "罗田县"
					},
					{
						"code": "421124",
						"name": "英山县"
					},
					{
						"code": "421125",
						"name": "浠水县"
					},
					{
						"code": "421126",
						"name": "蕲春县"
					},
					{
						"code": "421127",
						"name": "黄梅县"
					},
					{
						"code": "421181",
						"name": "麻城市"
					},
					{
						"code": "421182",
						"name": "武穴市"
					}

				]

			},
			{
				"code": "421200",
				"name": "咸宁市",
				"areaList": [{
						"code": "421202",
						"name": "咸安区"
					},
					{
						"code": "421221",
						"name": "嘉鱼县"
					},
					{
						"code": "421222",
						"name": "通城县"
					},
					{
						"code": "421223",
						"name": "崇阳县"
					},
					{
						"code": "421224",
						"name": "通山县"
					},
					{
						"code": "421281",
						"name": "赤壁市"
					}

				]

			},
			{
				"code": "421300",
				"name": "随州市",
				"areaList": [{
						"code": "421303",
						"name": "曾都区"
					},
					{
						"code": "421321",
						"name": "随县"
					},
					{
						"code": "421381",
						"name": "广水市"
					}

				]

			},
			{
				"code": "422800",
				"name": "恩施土家族苗族自治州",
				"areaList": [{
						"code": "422801",
						"name": "恩施市"
					},
					{
						"code": "422802",
						"name": "利川市"
					},
					{
						"code": "422822",
						"name": "建始县"
					},
					{
						"code": "422823",
						"name": "巴东县"
					},
					{
						"code": "422825",
						"name": "宣恩县"
					},
					{
						"code": "422826",
						"name": "咸丰县"
					},
					{
						"code": "422827",
						"name": "来凤县"
					},
					{
						"code": "422828",
						"name": "鹤峰县"
					}

				]

			}

		]

	},
	{
		"code": "430000",
		"name": "湖南省",
		"cityList": [{
				"code": "430100",
				"name": "长沙市",
				"areaList": [{
						"code": "430102",
						"name": "芙蓉区"
					},
					{
						"code": "430103",
						"name": "天心区"
					},
					{
						"code": "430104",
						"name": "岳麓区"
					},
					{
						"code": "430105",
						"name": "开福区"
					},
					{
						"code": "430111",
						"name": "雨花区"
					},
					{
						"code": "430112",
						"name": "望城区"
					},
					{
						"code": "430121",
						"name": "长沙县"
					},
					{
						"code": "430181",
						"name": "浏阳市"
					},
					{
						"code": "430182",
						"name": "宁乡市"
					}

				]

			},
			{
				"code": "430200",
				"name": "株洲市",
				"areaList": [{
						"code": "430202",
						"name": "荷塘区"
					},
					{
						"code": "430203",
						"name": "芦淞区"
					},
					{
						"code": "430204",
						"name": "石峰区"
					},
					{
						"code": "430211",
						"name": "天元区"
					},
					{
						"code": "430221",
						"name": "株洲县"
					},
					{
						"code": "430223",
						"name": "攸县"
					},
					{
						"code": "430224",
						"name": "茶陵县"
					},
					{
						"code": "430225",
						"name": "炎陵县"
					},
					{
						"code": "430281",
						"name": "醴陵市"
					}

				]

			},
			{
				"code": "430300",
				"name": "湘潭市",
				"areaList": [{
						"code": "430302",
						"name": "雨湖区"
					},
					{
						"code": "430304",
						"name": "岳塘区"
					},
					{
						"code": "430321",
						"name": "湘潭县"
					},
					{
						"code": "430381",
						"name": "湘乡市"
					},
					{
						"code": "430382",
						"name": "韶山市"
					}

				]

			},
			{
				"code": "430400",
				"name": "衡阳市",
				"areaList": [{
						"code": "430405",
						"name": "珠晖区"
					},
					{
						"code": "430406",
						"name": "雁峰区"
					},
					{
						"code": "430407",
						"name": "石鼓区"
					},
					{
						"code": "430408",
						"name": "蒸湘区"
					},
					{
						"code": "430412",
						"name": "南岳区"
					},
					{
						"code": "430421",
						"name": "衡阳县"
					},
					{
						"code": "430422",
						"name": "衡南县"
					},
					{
						"code": "430423",
						"name": "衡山县"
					},
					{
						"code": "430424",
						"name": "衡东县"
					},
					{
						"code": "430426",
						"name": "祁东县"
					},
					{
						"code": "430481",
						"name": "耒阳市"
					},
					{
						"code": "430482",
						"name": "常宁市"
					}

				]

			},
			{
				"code": "430500",
				"name": "邵阳市",
				"areaList": [{
						"code": "430502",
						"name": "双清区"
					},
					{
						"code": "430503",
						"name": "大祥区"
					},
					{
						"code": "430511",
						"name": "北塔区"
					},
					{
						"code": "430521",
						"name": "邵东县"
					},
					{
						"code": "430522",
						"name": "新邵县"
					},
					{
						"code": "430523",
						"name": "邵阳县"
					},
					{
						"code": "430524",
						"name": "隆回县"
					},
					{
						"code": "430525",
						"name": "洞口县"
					},
					{
						"code": "430527",
						"name": "绥宁县"
					},
					{
						"code": "430528",
						"name": "新宁县"
					},
					{
						"code": "430529",
						"name": "城步苗族自治县"
					},
					{
						"code": "430581",
						"name": "武冈市"
					}

				]

			},
			{
				"code": "430600",
				"name": "岳阳市",
				"areaList": [{
						"code": "430602",
						"name": "岳阳楼区"
					},
					{
						"code": "430603",
						"name": "云溪区"
					},
					{
						"code": "430611",
						"name": "君山区"
					},
					{
						"code": "430621",
						"name": "岳阳县"
					},
					{
						"code": "430623",
						"name": "华容县"
					},
					{
						"code": "430624",
						"name": "湘阴县"
					},
					{
						"code": "430626",
						"name": "平江县"
					},
					{
						"code": "430681",
						"name": "汨罗市"
					},
					{
						"code": "430682",
						"name": "临湘市"
					}

				]

			},
			{
				"code": "430700",
				"name": "常德市",
				"areaList": [{
						"code": "430702",
						"name": "武陵区"
					},
					{
						"code": "430703",
						"name": "鼎城区"
					},
					{
						"code": "430721",
						"name": "安乡县"
					},
					{
						"code": "430722",
						"name": "汉寿县"
					},
					{
						"code": "430723",
						"name": "澧县"
					},
					{
						"code": "430724",
						"name": "临澧县"
					},
					{
						"code": "430725",
						"name": "桃源县"
					},
					{
						"code": "430726",
						"name": "石门县"
					},
					{
						"code": "430781",
						"name": "津市市"
					}

				]

			},
			{
				"code": "430800",
				"name": "张家界市",
				"areaList": [{
						"code": "430802",
						"name": "永定区"
					},
					{
						"code": "430811",
						"name": "武陵源区"
					},
					{
						"code": "430821",
						"name": "慈利县"
					},
					{
						"code": "430822",
						"name": "桑植县"
					}

				]

			},
			{
				"code": "430900",
				"name": "益阳市",
				"areaList": [{
						"code": "430902",
						"name": "资阳区"
					},
					{
						"code": "430903",
						"name": "赫山区"
					},
					{
						"code": "430921",
						"name": "南县"
					},
					{
						"code": "430922",
						"name": "桃江县"
					},
					{
						"code": "430923",
						"name": "安化县"
					},
					{
						"code": "430981",
						"name": "沅江市"
					}

				]

			},
			{
				"code": "431000",
				"name": "郴州市",
				"areaList": [{
						"code": "431002",
						"name": "北湖区"
					},
					{
						"code": "431003",
						"name": "苏仙区"
					},
					{
						"code": "431021",
						"name": "桂阳县"
					},
					{
						"code": "431022",
						"name": "宜章县"
					},
					{
						"code": "431023",
						"name": "永兴县"
					},
					{
						"code": "431024",
						"name": "嘉禾县"
					},
					{
						"code": "431025",
						"name": "临武县"
					},
					{
						"code": "431026",
						"name": "汝城县"
					},
					{
						"code": "431027",
						"name": "桂东县"
					},
					{
						"code": "431028",
						"name": "安仁县"
					},
					{
						"code": "431081",
						"name": "资兴市"
					}

				]

			},
			{
				"code": "431100",
				"name": "永州市",
				"areaList": [{
						"code": "431102",
						"name": "零陵区"
					},
					{
						"code": "431103",
						"name": "冷水滩区"
					},
					{
						"code": "431121",
						"name": "祁阳县"
					},
					{
						"code": "431122",
						"name": "东安县"
					},
					{
						"code": "431123",
						"name": "双牌县"
					},
					{
						"code": "431124",
						"name": "道县"
					},
					{
						"code": "431125",
						"name": "江永县"
					},
					{
						"code": "431126",
						"name": "宁远县"
					},
					{
						"code": "431127",
						"name": "蓝山县"
					},
					{
						"code": "431128",
						"name": "新田县"
					},
					{
						"code": "431129",
						"name": "江华瑶族自治县"
					}

				]

			},
			{
				"code": "431200",
				"name": "怀化市",
				"areaList": [{
						"code": "431202",
						"name": "鹤城区"
					},
					{
						"code": "431221",
						"name": "中方县"
					},
					{
						"code": "431222",
						"name": "沅陵县"
					},
					{
						"code": "431223",
						"name": "辰溪县"
					},
					{
						"code": "431224",
						"name": "溆浦县"
					},
					{
						"code": "431225",
						"name": "会同县"
					},
					{
						"code": "431226",
						"name": "麻阳苗族自治县"
					},
					{
						"code": "431227",
						"name": "新晃侗族自治县"
					},
					{
						"code": "431228",
						"name": "芷江侗族自治县"
					},
					{
						"code": "431229",
						"name": "靖州苗族侗族自治县"
					},
					{
						"code": "431230",
						"name": "通道侗族自治县"
					},
					{
						"code": "431281",
						"name": "洪江市"
					}

				]

			},
			{
				"code": "431300",
				"name": "娄底市",
				"areaList": [{
						"code": "431302",
						"name": "娄星区"
					},
					{
						"code": "431321",
						"name": "双峰县"
					},
					{
						"code": "431322",
						"name": "新化县"
					},
					{
						"code": "431381",
						"name": "冷水江市"
					},
					{
						"code": "431382",
						"name": "涟源市"
					}

				]

			},
			{
				"code": "433100",
				"name": "湘西土家族苗族自治州",
				"areaList": [{
						"code": "433101",
						"name": "吉首市"
					},
					{
						"code": "433122",
						"name": "泸溪县"
					},
					{
						"code": "433123",
						"name": "凤凰县"
					},
					{
						"code": "433124",
						"name": "花垣县"
					},
					{
						"code": "433125",
						"name": "保靖县"
					},
					{
						"code": "433126",
						"name": "古丈县"
					},
					{
						"code": "433127",
						"name": "永顺县"
					},
					{
						"code": "433130",
						"name": "龙山县"
					}

				]

			}

		]

	},
	{
		"code": "440000",
		"name": "广东省",
		"cityList": [{
				"code": "440100",
				"name": "广州市",
				"areaList": [{
						"code": "440103",
						"name": "荔湾区"
					},
					{
						"code": "440104",
						"name": "越秀区"
					},
					{
						"code": "440105",
						"name": "海珠区"
					},
					{
						"code": "440106",
						"name": "天河区"
					},
					{
						"code": "440111",
						"name": "白云区"
					},
					{
						"code": "440112",
						"name": "黄埔区"
					},
					{
						"code": "440113",
						"name": "番禺区"
					},
					{
						"code": "440114",
						"name": "花都区"
					},
					{
						"code": "440115",
						"name": "南沙区"
					},
					{
						"code": "440117",
						"name": "从化区"
					},
					{
						"code": "440118",
						"name": "增城区"
					}

				]

			},
			{
				"code": "440200",
				"name": "韶关市",
				"areaList": [{
						"code": "440203",
						"name": "武江区"
					},
					{
						"code": "440204",
						"name": "浈江区"
					},
					{
						"code": "440205",
						"name": "曲江区"
					},
					{
						"code": "440222",
						"name": "始兴县"
					},
					{
						"code": "440224",
						"name": "仁化县"
					},
					{
						"code": "440229",
						"name": "翁源县"
					},
					{
						"code": "440232",
						"name": "乳源瑶族自治县"
					},
					{
						"code": "440233",
						"name": "新丰县"
					},
					{
						"code": "440281",
						"name": "乐昌市"
					},
					{
						"code": "440282",
						"name": "南雄市"
					}

				]

			},
			{
				"code": "440300",
				"name": "深圳市",
				"areaList": [{
						"code": "440303",
						"name": "罗湖区"
					},
					{
						"code": "440304",
						"name": "福田区"
					},
					{
						"code": "440305",
						"name": "南山区"
					},
					{
						"code": "440306",
						"name": "宝安区"
					},
					{
						"code": "440307",
						"name": "龙岗区"
					},
					{
						"code": "440308",
						"name": "盐田区"
					},
					{
						"code": "440309",
						"name": "龙华区"
					},
					{
						"code": "440310",
						"name": "坪山区"
					}

				]

			},
			{
				"code": "440400",
				"name": "珠海市",
				"areaList": [{
						"code": "440402",
						"name": "香洲区"
					},
					{
						"code": "440403",
						"name": "斗门区"
					},
					{
						"code": "440404",
						"name": "金湾区"
					}

				]

			},
			{
				"code": "440500",
				"name": "汕头市",
				"areaList": [{
						"code": "440507",
						"name": "龙湖区"
					},
					{
						"code": "440511",
						"name": "金平区"
					},
					{
						"code": "440512",
						"name": "濠江区"
					},
					{
						"code": "440513",
						"name": "潮阳区"
					},
					{
						"code": "440514",
						"name": "潮南区"
					},
					{
						"code": "440515",
						"name": "澄海区"
					},
					{
						"code": "440523",
						"name": "南澳县"
					}

				]

			},
			{
				"code": "440600",
				"name": "佛山市",
				"areaList": [{
						"code": "440604",
						"name": "禅城区"
					},
					{
						"code": "440605",
						"name": "南海区"
					},
					{
						"code": "440606",
						"name": "顺德区"
					},
					{
						"code": "440607",
						"name": "三水区"
					},
					{
						"code": "440608",
						"name": "高明区"
					}

				]

			},
			{
				"code": "440700",
				"name": "江门市",
				"areaList": [{
						"code": "440703",
						"name": "蓬江区"
					},
					{
						"code": "440704",
						"name": "江海区"
					},
					{
						"code": "440705",
						"name": "新会区"
					},
					{
						"code": "440781",
						"name": "台山市"
					},
					{
						"code": "440783",
						"name": "开平市"
					},
					{
						"code": "440784",
						"name": "鹤山市"
					},
					{
						"code": "440785",
						"name": "恩平市"
					}

				]

			},
			{
				"code": "440800",
				"name": "湛江市",
				"areaList": [{
						"code": "440802",
						"name": "赤坎区"
					},
					{
						"code": "440803",
						"name": "霞山区"
					},
					{
						"code": "440804",
						"name": "坡头区"
					},
					{
						"code": "440811",
						"name": "麻章区"
					},
					{
						"code": "440823",
						"name": "遂溪县"
					},
					{
						"code": "440825",
						"name": "徐闻县"
					},
					{
						"code": "440881",
						"name": "廉江市"
					},
					{
						"code": "440882",
						"name": "雷州市"
					},
					{
						"code": "440883",
						"name": "吴川市"
					}

				]

			},
			{
				"code": "440900",
				"name": "茂名市",
				"areaList": [{
						"code": "440902",
						"name": "茂南区"
					},
					{
						"code": "440904",
						"name": "电白区"
					},
					{
						"code": "440981",
						"name": "高州市"
					},
					{
						"code": "440982",
						"name": "化州市"
					},
					{
						"code": "440983",
						"name": "信宜市"
					}

				]

			},
			{
				"code": "441200",
				"name": "肇庆市",
				"areaList": [{
						"code": "441202",
						"name": "端州区"
					},
					{
						"code": "441203",
						"name": "鼎湖区"
					},
					{
						"code": "441204",
						"name": "高要区"
					},
					{
						"code": "441223",
						"name": "广宁县"
					},
					{
						"code": "441224",
						"name": "怀集县"
					},
					{
						"code": "441225",
						"name": "封开县"
					},
					{
						"code": "441226",
						"name": "德庆县"
					},
					{
						"code": "441284",
						"name": "四会市"
					}

				]

			},
			{
				"code": "441300",
				"name": "惠州市",
				"areaList": [{
						"code": "441302",
						"name": "惠城区"
					},
					{
						"code": "441303",
						"name": "惠阳区"
					},
					{
						"code": "441322",
						"name": "博罗县"
					},
					{
						"code": "441323",
						"name": "惠东县"
					},
					{
						"code": "441324",
						"name": "龙门县"
					}

				]

			},
			{
				"code": "441400",
				"name": "梅州市",
				"areaList": [{
						"code": "441402",
						"name": "梅江区"
					},
					{
						"code": "441403",
						"name": "梅县区"
					},
					{
						"code": "441422",
						"name": "大埔县"
					},
					{
						"code": "441423",
						"name": "丰顺县"
					},
					{
						"code": "441424",
						"name": "五华县"
					},
					{
						"code": "441426",
						"name": "平远县"
					},
					{
						"code": "441427",
						"name": "蕉岭县"
					},
					{
						"code": "441481",
						"name": "兴宁市"
					}

				]

			},
			{
				"code": "441500",
				"name": "汕尾市",
				"areaList": [{
						"code": "441502",
						"name": "城区"
					},
					{
						"code": "441521",
						"name": "海丰县"
					},
					{
						"code": "441523",
						"name": "陆河县"
					},
					{
						"code": "441581",
						"name": "陆丰市"
					}

				]

			},
			{
				"code": "441600",
				"name": "河源市",
				"areaList": [{
						"code": "441602",
						"name": "源城区"
					},
					{
						"code": "441621",
						"name": "紫金县"
					},
					{
						"code": "441622",
						"name": "龙川县"
					},
					{
						"code": "441623",
						"name": "连平县"
					},
					{
						"code": "441624",
						"name": "和平县"
					},
					{
						"code": "441625",
						"name": "东源县"
					}

				]

			},
			{
				"code": "441700",
				"name": "阳江市",
				"areaList": [{
						"code": "441702",
						"name": "江城区"
					},
					{
						"code": "441704",
						"name": "阳东区"
					},
					{
						"code": "441721",
						"name": "阳西县"
					},
					{
						"code": "441781",
						"name": "阳春市"
					}

				]

			},
			{
				"code": "441800",
				"name": "清远市",
				"areaList": [{
						"code": "441802",
						"name": "清城区"
					},
					{
						"code": "441803",
						"name": "清新区"
					},
					{
						"code": "441821",
						"name": "佛冈县"
					},
					{
						"code": "441823",
						"name": "阳山县"
					},
					{
						"code": "441825",
						"name": "连山壮族瑶族自治县"
					},
					{
						"code": "441826",
						"name": "连南瑶族自治县"
					},
					{
						"code": "441881",
						"name": "英德市"
					},
					{
						"code": "441882",
						"name": "连州市"
					}

				]

			},
			{
				"code": "441900",
				"name": "东莞市",
				"areaList": [

				]

			},
			{
				"code": "442000",
				"name": "中山市",
				"areaList": [

				]

			},
			{
				"code": "445100",
				"name": "潮州市",
				"areaList": [{
						"code": "445102",
						"name": "湘桥区"
					},
					{
						"code": "445103",
						"name": "潮安区"
					},
					{
						"code": "445122",
						"name": "饶平县"
					}

				]

			},
			{
				"code": "445200",
				"name": "揭阳市",
				"areaList": [{
						"code": "445202",
						"name": "榕城区"
					},
					{
						"code": "445203",
						"name": "揭东区"
					},
					{
						"code": "445222",
						"name": "揭西县"
					},
					{
						"code": "445224",
						"name": "惠来县"
					},
					{
						"code": "445281",
						"name": "普宁市"
					}

				]

			},
			{
				"code": "445300",
				"name": "云浮市",
				"areaList": [{
						"code": "445302",
						"name": "云城区"
					},
					{
						"code": "445303",
						"name": "云安区"
					},
					{
						"code": "445321",
						"name": "新兴县"
					},
					{
						"code": "445322",
						"name": "郁南县"
					},
					{
						"code": "445381",
						"name": "罗定市"
					}

				]

			}

		]

	},
	{
		"code": "450000",
		"name": "广西壮族自治区",
		"cityList": [{
				"code": "450100",
				"name": "南宁市",
				"areaList": [{
						"code": "450102",
						"name": "兴宁区"
					},
					{
						"code": "450103",
						"name": "青秀区"
					},
					{
						"code": "450105",
						"name": "江南区"
					},
					{
						"code": "450107",
						"name": "西乡塘区"
					},
					{
						"code": "450108",
						"name": "良庆区"
					},
					{
						"code": "450109",
						"name": "邕宁区"
					},
					{
						"code": "450110",
						"name": "武鸣区"
					},
					{
						"code": "450123",
						"name": "隆安县"
					},
					{
						"code": "450124",
						"name": "马山县"
					},
					{
						"code": "450125",
						"name": "上林县"
					},
					{
						"code": "450126",
						"name": "宾阳县"
					},
					{
						"code": "450127",
						"name": "横县"
					}

				]

			},
			{
				"code": "450200",
				"name": "柳州市",
				"areaList": [{
						"code": "450202",
						"name": "城中区"
					},
					{
						"code": "450203",
						"name": "鱼峰区"
					},
					{
						"code": "450204",
						"name": "柳南区"
					},
					{
						"code": "450205",
						"name": "柳北区"
					},
					{
						"code": "450206",
						"name": "柳江区"
					},
					{
						"code": "450222",
						"name": "柳城县"
					},
					{
						"code": "450223",
						"name": "鹿寨县"
					},
					{
						"code": "450224",
						"name": "融安县"
					},
					{
						"code": "450225",
						"name": "融水苗族自治县"
					},
					{
						"code": "450226",
						"name": "三江侗族自治县"
					}

				]

			},
			{
				"code": "450300",
				"name": "桂林市",
				"areaList": [{
						"code": "450302",
						"name": "秀峰区"
					},
					{
						"code": "450303",
						"name": "叠彩区"
					},
					{
						"code": "450304",
						"name": "象山区"
					},
					{
						"code": "450305",
						"name": "七星区"
					},
					{
						"code": "450311",
						"name": "雁山区"
					},
					{
						"code": "450312",
						"name": "临桂区"
					},
					{
						"code": "450321",
						"name": "阳朔县"
					},
					{
						"code": "450323",
						"name": "灵川县"
					},
					{
						"code": "450324",
						"name": "全州县"
					},
					{
						"code": "450325",
						"name": "兴安县"
					},
					{
						"code": "450326",
						"name": "永福县"
					},
					{
						"code": "450327",
						"name": "灌阳县"
					},
					{
						"code": "450328",
						"name": "龙胜各族自治县"
					},
					{
						"code": "450329",
						"name": "资源县"
					},
					{
						"code": "450330",
						"name": "平乐县"
					},
					{
						"code": "450331",
						"name": "荔浦县"
					},
					{
						"code": "450332",
						"name": "恭城瑶族自治县"
					}

				]

			},
			{
				"code": "450400",
				"name": "梧州市",
				"areaList": [{
						"code": "450403",
						"name": "万秀区"
					},
					{
						"code": "450405",
						"name": "长洲区"
					},
					{
						"code": "450406",
						"name": "龙圩区"
					},
					{
						"code": "450421",
						"name": "苍梧县"
					},
					{
						"code": "450422",
						"name": "藤县"
					},
					{
						"code": "450423",
						"name": "蒙山县"
					},
					{
						"code": "450481",
						"name": "岑溪市"
					}

				]

			},
			{
				"code": "450500",
				"name": "北海市",
				"areaList": [{
						"code": "450502",
						"name": "海城区"
					},
					{
						"code": "450503",
						"name": "银海区"
					},
					{
						"code": "450512",
						"name": "铁山港区"
					},
					{
						"code": "450521",
						"name": "合浦县"
					}

				]

			},
			{
				"code": "450600",
				"name": "防城港市",
				"areaList": [{
						"code": "450602",
						"name": "港口区"
					},
					{
						"code": "450603",
						"name": "防城区"
					},
					{
						"code": "450621",
						"name": "上思县"
					},
					{
						"code": "450681",
						"name": "东兴市"
					}

				]

			},
			{
				"code": "450700",
				"name": "钦州市",
				"areaList": [{
						"code": "450702",
						"name": "钦南区"
					},
					{
						"code": "450703",
						"name": "钦北区"
					},
					{
						"code": "450721",
						"name": "灵山县"
					},
					{
						"code": "450722",
						"name": "浦北县"
					}

				]

			},
			{
				"code": "450800",
				"name": "贵港市",
				"areaList": [{
						"code": "450802",
						"name": "港北区"
					},
					{
						"code": "450803",
						"name": "港南区"
					},
					{
						"code": "450804",
						"name": "覃塘区"
					},
					{
						"code": "450821",
						"name": "平南县"
					},
					{
						"code": "450881",
						"name": "桂平市"
					}

				]

			},
			{
				"code": "450900",
				"name": "玉林市",
				"areaList": [{
						"code": "450902",
						"name": "玉州区"
					},
					{
						"code": "450903",
						"name": "福绵区"
					},
					{
						"code": "450921",
						"name": "容县"
					},
					{
						"code": "450922",
						"name": "陆川县"
					},
					{
						"code": "450923",
						"name": "博白县"
					},
					{
						"code": "450924",
						"name": "兴业县"
					},
					{
						"code": "450981",
						"name": "北流市"
					}

				]

			},
			{
				"code": "451000",
				"name": "百色市",
				"areaList": [{
						"code": "451002",
						"name": "右江区"
					},
					{
						"code": "451021",
						"name": "田阳县"
					},
					{
						"code": "451022",
						"name": "田东县"
					},
					{
						"code": "451023",
						"name": "平果县"
					},
					{
						"code": "451024",
						"name": "德保县"
					},
					{
						"code": "451026",
						"name": "那坡县"
					},
					{
						"code": "451027",
						"name": "凌云县"
					},
					{
						"code": "451028",
						"name": "乐业县"
					},
					{
						"code": "451029",
						"name": "田林县"
					},
					{
						"code": "451030",
						"name": "西林县"
					},
					{
						"code": "451031",
						"name": "隆林各族自治县"
					},
					{
						"code": "451081",
						"name": "靖西市"
					}

				]

			},
			{
				"code": "451100",
				"name": "贺州市",
				"areaList": [{
						"code": "451102",
						"name": "八步区"
					},
					{
						"code": "451103",
						"name": "平桂区"
					},
					{
						"code": "451121",
						"name": "昭平县"
					},
					{
						"code": "451122",
						"name": "钟山县"
					},
					{
						"code": "451123",
						"name": "富川瑶族自治县"
					}

				]

			},
			{
				"code": "451200",
				"name": "河池市",
				"areaList": [{
						"code": "451202",
						"name": "金城江区"
					},
					{
						"code": "451203",
						"name": "宜州区"
					},
					{
						"code": "451221",
						"name": "南丹县"
					},
					{
						"code": "451222",
						"name": "天峨县"
					},
					{
						"code": "451223",
						"name": "凤山县"
					},
					{
						"code": "451224",
						"name": "东兰县"
					},
					{
						"code": "451225",
						"name": "罗城仫佬族自治县"
					},
					{
						"code": "451226",
						"name": "环江毛南族自治县"
					},
					{
						"code": "451227",
						"name": "巴马瑶族自治县"
					},
					{
						"code": "451228",
						"name": "都安瑶族自治县"
					},
					{
						"code": "451229",
						"name": "大化瑶族自治县"
					}

				]

			},
			{
				"code": "451300",
				"name": "来宾市",
				"areaList": [{
						"code": "451302",
						"name": "兴宾区"
					},
					{
						"code": "451321",
						"name": "忻城县"
					},
					{
						"code": "451322",
						"name": "象州县"
					},
					{
						"code": "451323",
						"name": "武宣县"
					},
					{
						"code": "451324",
						"name": "金秀瑶族自治县"
					},
					{
						"code": "451381",
						"name": "合山市"
					}

				]

			},
			{
				"code": "451400",
				"name": "崇左市",
				"areaList": [{
						"code": "451402",
						"name": "江州区"
					},
					{
						"code": "451421",
						"name": "扶绥县"
					},
					{
						"code": "451422",
						"name": "宁明县"
					},
					{
						"code": "451423",
						"name": "龙州县"
					},
					{
						"code": "451424",
						"name": "大新县"
					},
					{
						"code": "451425",
						"name": "天等县"
					},
					{
						"code": "451481",
						"name": "凭祥市"
					}

				]

			}

		]

	},
	{
		"code": "460000",
		"name": "海南省",
		"cityList": [{
				"code": "460100",
				"name": "海口市",
				"areaList": [{
						"code": "460105",
						"name": "秀英区"
					},
					{
						"code": "460106",
						"name": "龙华区"
					},
					{
						"code": "460107",
						"name": "琼山区"
					},
					{
						"code": "460108",
						"name": "美兰区"
					}

				]

			},
			{
				"code": "460200",
				"name": "三亚市",
				"areaList": [{
						"code": "460202",
						"name": "海棠区"
					},
					{
						"code": "460203",
						"name": "吉阳区"
					},
					{
						"code": "460204",
						"name": "天涯区"
					},
					{
						"code": "460205",
						"name": "崖州区"
					}

				]

			},
			{
				"code": "460300",
				"name": "三沙市",
				"areaList": [

				]

			},
			{
				"code": "460400",
				"name": "儋州市",
				"areaList": [

				]

			}

		]

	},
	{
		"code": "500000",
		"name": "重庆市",
		"cityList": [{
				"code": "500000",
				"name": "重庆市",
				"areaList": [{
						"code": "500101",
						"name": "万州区"
					},
					{
						"code": "500102",
						"name": "涪陵区"
					},
					{
						"code": "500103",
						"name": "渝中区"
					},
					{
						"code": "500104",
						"name": "大渡口区"
					},
					{
						"code": "500105",
						"name": "江北区"
					},
					{
						"code": "500106",
						"name": "沙坪坝区"
					},
					{
						"code": "500107",
						"name": "九龙坡区"
					},
					{
						"code": "500108",
						"name": "南岸区"
					},
					{
						"code": "500109",
						"name": "北碚区"
					},
					{
						"code": "500110",
						"name": "綦江区"
					},
					{
						"code": "500111",
						"name": "大足区"
					},
					{
						"code": "500112",
						"name": "渝北区"
					},
					{
						"code": "500113",
						"name": "巴南区"
					},
					{
						"code": "500114",
						"name": "黔江区"
					},
					{
						"code": "500115",
						"name": "长寿区"
					},
					{
						"code": "500116",
						"name": "江津区"
					},
					{
						"code": "500117",
						"name": "合川区"
					},
					{
						"code": "500118",
						"name": "永川区"
					},
					{
						"code": "500119",
						"name": "南川区"
					},
					{
						"code": "500120",
						"name": "璧山区"
					},
					{
						"code": "500151",
						"name": "铜梁区"
					},
					{
						"code": "500152",
						"name": "潼南区"
					},
					{
						"code": "500153",
						"name": "荣昌区"
					},
					{
						"code": "500154",
						"name": "开州区"
					},
					{
						"code": "500155",
						"name": "梁平区"
					},
					{
						"code": "500156",
						"name": "武隆区"
					},
					{
						"code": "500229",
						"name": "城口县"
					},
					{
						"code": "500230",
						"name": "丰都县"
					},
					{
						"code": "500231",
						"name": "垫江县"
					},
					{
						"code": "500233",
						"name": "忠县"
					},
					{
						"code": "500235",
						"name": "云阳县"
					},
					{
						"code": "500236",
						"name": "奉节县"
					},
					{
						"code": "500237",
						"name": "巫山县"
					},
					{
						"code": "500238",
						"name": "巫溪县"
					},
					{
						"code": "500240",
						"name": "石柱土家族自治县"
					},
					{
						"code": "500241",
						"name": "秀山土家族苗族自治县"
					},
					{
						"code": "500242",
						"name": "酉阳土家族苗族自治县"
					},
					{
						"code": "500243",
						"name": "彭水苗族土家族自治县"
					}

				]

			}

		]

	},
	{
		"code": "510000",
		"name": "四川省",
		"cityList": [{
				"code": "510100",
				"name": "成都市",
				"areaList": [{
						"code": "510104",
						"name": "锦江区"
					},
					{
						"code": "510105",
						"name": "青羊区"
					},
					{
						"code": "510106",
						"name": "金牛区"
					},
					{
						"code": "510107",
						"name": "武侯区"
					},
					{
						"code": "510108",
						"name": "成华区"
					},
					{
						"code": "510112",
						"name": "龙泉驿区"
					},
					{
						"code": "510113",
						"name": "青白江区"
					},
					{
						"code": "510114",
						"name": "新都区"
					},
					{
						"code": "510115",
						"name": "温江区"
					},
					{
						"code": "510116",
						"name": "双流区"
					},
					{
						"code": "510117",
						"name": "郫都区"
					},
					{
						"code": "510121",
						"name": "金堂县"
					},
					{
						"code": "510129",
						"name": "大邑县"
					},
					{
						"code": "510131",
						"name": "蒲江县"
					},
					{
						"code": "510132",
						"name": "新津县"
					},
					{
						"code": "510181",
						"name": "都江堰市"
					},
					{
						"code": "510182",
						"name": "彭州市"
					},
					{
						"code": "510183",
						"name": "邛崃市"
					},
					{
						"code": "510184",
						"name": "崇州市"
					},
					{
						"code": "510185",
						"name": "简阳市"
					}

				]

			},
			{
				"code": "510300",
				"name": "自贡市",
				"areaList": [{
						"code": "510302",
						"name": "自流井区"
					},
					{
						"code": "510303",
						"name": "贡井区"
					},
					{
						"code": "510304",
						"name": "大安区"
					},
					{
						"code": "510311",
						"name": "沿滩区"
					},
					{
						"code": "510321",
						"name": "荣县"
					},
					{
						"code": "510322",
						"name": "富顺县"
					}

				]

			},
			{
				"code": "510400",
				"name": "攀枝花市",
				"areaList": [{
						"code": "510402",
						"name": "东区"
					},
					{
						"code": "510403",
						"name": "西区"
					},
					{
						"code": "510411",
						"name": "仁和区"
					},
					{
						"code": "510421",
						"name": "米易县"
					},
					{
						"code": "510422",
						"name": "盐边县"
					}

				]

			},
			{
				"code": "510500",
				"name": "泸州市",
				"areaList": [{
						"code": "510502",
						"name": "江阳区"
					},
					{
						"code": "510503",
						"name": "纳溪区"
					},
					{
						"code": "510504",
						"name": "龙马潭区"
					},
					{
						"code": "510521",
						"name": "泸县"
					},
					{
						"code": "510522",
						"name": "合江县"
					},
					{
						"code": "510524",
						"name": "叙永县"
					},
					{
						"code": "510525",
						"name": "古蔺县"
					}

				]

			},
			{
				"code": "510600",
				"name": "德阳市",
				"areaList": [{
						"code": "510603",
						"name": "旌阳区"
					},
					{
						"code": "510604",
						"name": "罗江区"
					},
					{
						"code": "510623",
						"name": "中江县"
					},
					{
						"code": "510681",
						"name": "广汉市"
					},
					{
						"code": "510682",
						"name": "什邡市"
					},
					{
						"code": "510683",
						"name": "绵竹市"
					}

				]

			},
			{
				"code": "510700",
				"name": "绵阳市",
				"areaList": [{
						"code": "510703",
						"name": "涪城区"
					},
					{
						"code": "510704",
						"name": "游仙区"
					},
					{
						"code": "510705",
						"name": "安州区"
					},
					{
						"code": "510722",
						"name": "三台县"
					},
					{
						"code": "510723",
						"name": "盐亭县"
					},
					{
						"code": "510725",
						"name": "梓潼县"
					},
					{
						"code": "510726",
						"name": "北川羌族自治县"
					},
					{
						"code": "510727",
						"name": "平武县"
					},
					{
						"code": "510781",
						"name": "江油市"
					}

				]

			},
			{
				"code": "510800",
				"name": "广元市",
				"areaList": [{
						"code": "510802",
						"name": "利州区"
					},
					{
						"code": "510811",
						"name": "昭化区"
					},
					{
						"code": "510812",
						"name": "朝天区"
					},
					{
						"code": "510821",
						"name": "旺苍县"
					},
					{
						"code": "510822",
						"name": "青川县"
					},
					{
						"code": "510823",
						"name": "剑阁县"
					},
					{
						"code": "510824",
						"name": "苍溪县"
					}

				]

			},
			{
				"code": "510900",
				"name": "遂宁市",
				"areaList": [{
						"code": "510903",
						"name": "船山区"
					},
					{
						"code": "510904",
						"name": "安居区"
					},
					{
						"code": "510921",
						"name": "蓬溪县"
					},
					{
						"code": "510922",
						"name": "射洪县"
					},
					{
						"code": "510923",
						"name": "大英县"
					}

				]

			},
			{
				"code": "511000",
				"name": "内江市",
				"areaList": [{
						"code": "511002",
						"name": "市中区"
					},
					{
						"code": "511011",
						"name": "东兴区"
					},
					{
						"code": "511024",
						"name": "威远县"
					},
					{
						"code": "511025",
						"name": "资中县"
					},
					{
						"code": "511083",
						"name": "隆昌市"
					}

				]

			},
			{
				"code": "511100",
				"name": "乐山市",
				"areaList": [{
						"code": "511102",
						"name": "市中区"
					},
					{
						"code": "511111",
						"name": "沙湾区"
					},
					{
						"code": "511112",
						"name": "五通桥区"
					},
					{
						"code": "511113",
						"name": "金口河区"
					},
					{
						"code": "511123",
						"name": "犍为县"
					},
					{
						"code": "511124",
						"name": "井研县"
					},
					{
						"code": "511126",
						"name": "夹江县"
					},
					{
						"code": "511129",
						"name": "沐川县"
					},
					{
						"code": "511132",
						"name": "峨边彝族自治县"
					},
					{
						"code": "511133",
						"name": "马边彝族自治县"
					},
					{
						"code": "511181",
						"name": "峨眉山市"
					}

				]

			},
			{
				"code": "511300",
				"name": "南充市",
				"areaList": [{
						"code": "511302",
						"name": "顺庆区"
					},
					{
						"code": "511303",
						"name": "高坪区"
					},
					{
						"code": "511304",
						"name": "嘉陵区"
					},
					{
						"code": "511321",
						"name": "南部县"
					},
					{
						"code": "511322",
						"name": "营山县"
					},
					{
						"code": "511323",
						"name": "蓬安县"
					},
					{
						"code": "511324",
						"name": "仪陇县"
					},
					{
						"code": "511325",
						"name": "西充县"
					},
					{
						"code": "511381",
						"name": "阆中市"
					}

				]

			},
			{
				"code": "511400",
				"name": "眉山市",
				"areaList": [{
						"code": "511402",
						"name": "东坡区"
					},
					{
						"code": "511403",
						"name": "彭山区"
					},
					{
						"code": "511421",
						"name": "仁寿县"
					},
					{
						"code": "511423",
						"name": "洪雅县"
					},
					{
						"code": "511424",
						"name": "丹棱县"
					},
					{
						"code": "511425",
						"name": "青神县"
					}

				]

			},
			{
				"code": "511500",
				"name": "宜宾市",
				"areaList": [{
						"code": "511502",
						"name": "翠屏区"
					},
					{
						"code": "511503",
						"name": "南溪区"
					},
					{
						"code": "511521",
						"name": "宜宾县"
					},
					{
						"code": "511523",
						"name": "江安县"
					},
					{
						"code": "511524",
						"name": "长宁县"
					},
					{
						"code": "511525",
						"name": "高县"
					},
					{
						"code": "511526",
						"name": "珙县"
					},
					{
						"code": "511527",
						"name": "筠连县"
					},
					{
						"code": "511528",
						"name": "兴文县"
					},
					{
						"code": "511529",
						"name": "屏山县"
					}

				]

			},
			{
				"code": "511600",
				"name": "广安市",
				"areaList": [{
						"code": "511602",
						"name": "广安区"
					},
					{
						"code": "511603",
						"name": "前锋区"
					},
					{
						"code": "511621",
						"name": "岳池县"
					},
					{
						"code": "511622",
						"name": "武胜县"
					},
					{
						"code": "511623",
						"name": "邻水县"
					},
					{
						"code": "511681",
						"name": "华蓥市"
					}

				]

			},
			{
				"code": "511700",
				"name": "达州市",
				"areaList": [{
						"code": "511702",
						"name": "通川区"
					},
					{
						"code": "511703",
						"name": "达川区"
					},
					{
						"code": "511722",
						"name": "宣汉县"
					},
					{
						"code": "511723",
						"name": "开江县"
					},
					{
						"code": "511724",
						"name": "大竹县"
					},
					{
						"code": "511725",
						"name": "渠县"
					},
					{
						"code": "511781",
						"name": "万源市"
					}

				]

			},
			{
				"code": "511800",
				"name": "雅安市",
				"areaList": [{
						"code": "511802",
						"name": "雨城区"
					},
					{
						"code": "511803",
						"name": "名山区"
					},
					{
						"code": "511822",
						"name": "荥经县"
					},
					{
						"code": "511823",
						"name": "汉源县"
					},
					{
						"code": "511824",
						"name": "石棉县"
					},
					{
						"code": "511825",
						"name": "天全县"
					},
					{
						"code": "511826",
						"name": "芦山县"
					},
					{
						"code": "511827",
						"name": "宝兴县"
					}

				]

			},
			{
				"code": "511900",
				"name": "巴中市",
				"areaList": [{
						"code": "511902",
						"name": "巴州区"
					},
					{
						"code": "511903",
						"name": "恩阳区"
					},
					{
						"code": "511921",
						"name": "通江县"
					},
					{
						"code": "511922",
						"name": "南江县"
					},
					{
						"code": "511923",
						"name": "平昌县"
					}

				]

			},
			{
				"code": "512000",
				"name": "资阳市",
				"areaList": [{
						"code": "512002",
						"name": "雁江区"
					},
					{
						"code": "512021",
						"name": "安岳县"
					},
					{
						"code": "512022",
						"name": "乐至县"
					}

				]

			},
			{
				"code": "513200",
				"name": "阿坝藏族羌族自治州",
				"areaList": [{
						"code": "513201",
						"name": "马尔康市"
					},
					{
						"code": "513221",
						"name": "汶川县"
					},
					{
						"code": "513222",
						"name": "理县"
					},
					{
						"code": "513223",
						"name": "茂县"
					},
					{
						"code": "513224",
						"name": "松潘县"
					},
					{
						"code": "513225",
						"name": "九寨沟县"
					},
					{
						"code": "513226",
						"name": "金川县"
					},
					{
						"code": "513227",
						"name": "小金县"
					},
					{
						"code": "513228",
						"name": "黑水县"
					},
					{
						"code": "513230",
						"name": "壤塘县"
					},
					{
						"code": "513231",
						"name": "阿坝县"
					},
					{
						"code": "513232",
						"name": "若尔盖县"
					},
					{
						"code": "513233",
						"name": "红原县"
					}

				]

			},
			{
				"code": "513300",
				"name": "甘孜藏族自治州",
				"areaList": [{
						"code": "513301",
						"name": "康定市"
					},
					{
						"code": "513322",
						"name": "泸定县"
					},
					{
						"code": "513323",
						"name": "丹巴县"
					},
					{
						"code": "513324",
						"name": "九龙县"
					},
					{
						"code": "513325",
						"name": "雅江县"
					},
					{
						"code": "513326",
						"name": "道孚县"
					},
					{
						"code": "513327",
						"name": "炉霍县"
					},
					{
						"code": "513328",
						"name": "甘孜县"
					},
					{
						"code": "513329",
						"name": "新龙县"
					},
					{
						"code": "513330",
						"name": "德格县"
					},
					{
						"code": "513331",
						"name": "白玉县"
					},
					{
						"code": "513332",
						"name": "石渠县"
					},
					{
						"code": "513333",
						"name": "色达县"
					},
					{
						"code": "513334",
						"name": "理塘县"
					},
					{
						"code": "513335",
						"name": "巴塘县"
					},
					{
						"code": "513336",
						"name": "乡城县"
					},
					{
						"code": "513337",
						"name": "稻城县"
					},
					{
						"code": "513338",
						"name": "得荣县"
					}

				]

			},
			{
				"code": "513400",
				"name": "凉山彝族自治州",
				"areaList": [{
						"code": "513401",
						"name": "西昌市"
					},
					{
						"code": "513422",
						"name": "木里藏族自治县"
					},
					{
						"code": "513423",
						"name": "盐源县"
					},
					{
						"code": "513424",
						"name": "德昌县"
					},
					{
						"code": "513425",
						"name": "会理县"
					},
					{
						"code": "513426",
						"name": "会东县"
					},
					{
						"code": "513427",
						"name": "宁南县"
					},
					{
						"code": "513428",
						"name": "普格县"
					},
					{
						"code": "513429",
						"name": "布拖县"
					},
					{
						"code": "513430",
						"name": "金阳县"
					},
					{
						"code": "513431",
						"name": "昭觉县"
					},
					{
						"code": "513432",
						"name": "喜德县"
					},
					{
						"code": "513433",
						"name": "冕宁县"
					},
					{
						"code": "513434",
						"name": "越西县"
					},
					{
						"code": "513435",
						"name": "甘洛县"
					},
					{
						"code": "513436",
						"name": "美姑县"
					},
					{
						"code": "513437",
						"name": "雷波县"
					}

				]

			}

		]

	},
	{
		"code": "520000",
		"name": "贵州省",
		"cityList": [{
				"code": "520100",
				"name": "贵阳市",
				"areaList": [{
						"code": "520102",
						"name": "南明区"
					},
					{
						"code": "520103",
						"name": "云岩区"
					},
					{
						"code": "520111",
						"name": "花溪区"
					},
					{
						"code": "520112",
						"name": "乌当区"
					},
					{
						"code": "520113",
						"name": "白云区"
					},
					{
						"code": "520115",
						"name": "观山湖区"
					},
					{
						"code": "520121",
						"name": "开阳县"
					},
					{
						"code": "520122",
						"name": "息烽县"
					},
					{
						"code": "520123",
						"name": "修文县"
					},
					{
						"code": "520181",
						"name": "清镇市"
					}

				]

			},
			{
				"code": "520200",
				"name": "六盘水市",
				"areaList": [{
						"code": "520201",
						"name": "钟山区"
					},
					{
						"code": "520203",
						"name": "六枝特区"
					},
					{
						"code": "520221",
						"name": "水城县"
					},
					{
						"code": "520281",
						"name": "盘州市"
					}

				]

			},
			{
				"code": "520300",
				"name": "遵义市",
				"areaList": [{
						"code": "520302",
						"name": "红花岗区"
					},
					{
						"code": "520303",
						"name": "汇川区"
					},
					{
						"code": "520304",
						"name": "播州区"
					},
					{
						"code": "520322",
						"name": "桐梓县"
					},
					{
						"code": "520323",
						"name": "绥阳县"
					},
					{
						"code": "520324",
						"name": "正安县"
					},
					{
						"code": "520325",
						"name": "道真仡佬族苗族自治县"
					},
					{
						"code": "520326",
						"name": "务川仡佬族苗族自治县"
					},
					{
						"code": "520327",
						"name": "凤冈县"
					},
					{
						"code": "520328",
						"name": "湄潭县"
					},
					{
						"code": "520329",
						"name": "余庆县"
					},
					{
						"code": "520330",
						"name": "习水县"
					},
					{
						"code": "520381",
						"name": "赤水市"
					},
					{
						"code": "520382",
						"name": "仁怀市"
					}

				]

			},
			{
				"code": "520400",
				"name": "安顺市",
				"areaList": [{
						"code": "520402",
						"name": "西秀区"
					},
					{
						"code": "520403",
						"name": "平坝区"
					},
					{
						"code": "520422",
						"name": "普定县"
					},
					{
						"code": "520423",
						"name": "镇宁布依族苗族自治县"
					},
					{
						"code": "520424",
						"name": "关岭布依族苗族自治县"
					},
					{
						"code": "520425",
						"name": "紫云苗族布依族自治县"
					}

				]

			},
			{
				"code": "520500",
				"name": "毕节市",
				"areaList": [{
						"code": "520502",
						"name": "七星关区"
					},
					{
						"code": "520521",
						"name": "大方县"
					},
					{
						"code": "520522",
						"name": "黔西县"
					},
					{
						"code": "520523",
						"name": "金沙县"
					},
					{
						"code": "520524",
						"name": "织金县"
					},
					{
						"code": "520525",
						"name": "纳雍县"
					},
					{
						"code": "520526",
						"name": "威宁彝族回族苗族自治县"
					},
					{
						"code": "520527",
						"name": "赫章县"
					}

				]

			},
			{
				"code": "520600",
				"name": "铜仁市",
				"areaList": [{
						"code": "520602",
						"name": "碧江区"
					},
					{
						"code": "520603",
						"name": "万山区"
					},
					{
						"code": "520621",
						"name": "江口县"
					},
					{
						"code": "520622",
						"name": "玉屏侗族自治县"
					},
					{
						"code": "520623",
						"name": "石阡县"
					},
					{
						"code": "520624",
						"name": "思南县"
					},
					{
						"code": "520625",
						"name": "印江土家族苗族自治县"
					},
					{
						"code": "520626",
						"name": "德江县"
					},
					{
						"code": "520627",
						"name": "沿河土家族自治县"
					},
					{
						"code": "520628",
						"name": "松桃苗族自治县"
					}

				]

			},
			{
				"code": "522300",
				"name": "黔西南布依族苗族自治州",
				"areaList": [{
						"code": "522301",
						"name": "兴义市"
					},
					{
						"code": "522322",
						"name": "兴仁县"
					},
					{
						"code": "522323",
						"name": "普安县"
					},
					{
						"code": "522324",
						"name": "晴隆县"
					},
					{
						"code": "522325",
						"name": "贞丰县"
					},
					{
						"code": "522326",
						"name": "望谟县"
					},
					{
						"code": "522327",
						"name": "册亨县"
					},
					{
						"code": "522328",
						"name": "安龙县"
					}

				]

			},
			{
				"code": "522600",
				"name": "黔东南苗族侗族自治州",
				"areaList": [{
						"code": "522601",
						"name": "凯里市"
					},
					{
						"code": "522622",
						"name": "黄平县"
					},
					{
						"code": "522623",
						"name": "施秉县"
					},
					{
						"code": "522624",
						"name": "三穗县"
					},
					{
						"code": "522625",
						"name": "镇远县"
					},
					{
						"code": "522626",
						"name": "岑巩县"
					},
					{
						"code": "522627",
						"name": "天柱县"
					},
					{
						"code": "522628",
						"name": "锦屏县"
					},
					{
						"code": "522629",
						"name": "剑河县"
					},
					{
						"code": "522630",
						"name": "台江县"
					},
					{
						"code": "522631",
						"name": "黎平县"
					},
					{
						"code": "522632",
						"name": "榕江县"
					},
					{
						"code": "522633",
						"name": "从江县"
					},
					{
						"code": "522634",
						"name": "雷山县"
					},
					{
						"code": "522635",
						"name": "麻江县"
					},
					{
						"code": "522636",
						"name": "丹寨县"
					}

				]

			},
			{
				"code": "522700",
				"name": "黔南布依族苗族自治州",
				"areaList": [{
						"code": "522701",
						"name": "都匀市"
					},
					{
						"code": "522702",
						"name": "福泉市"
					},
					{
						"code": "522722",
						"name": "荔波县"
					},
					{
						"code": "522723",
						"name": "贵定县"
					},
					{
						"code": "522725",
						"name": "瓮安县"
					},
					{
						"code": "522726",
						"name": "独山县"
					},
					{
						"code": "522727",
						"name": "平塘县"
					},
					{
						"code": "522728",
						"name": "罗甸县"
					},
					{
						"code": "522729",
						"name": "长顺县"
					},
					{
						"code": "522730",
						"name": "龙里县"
					},
					{
						"code": "522731",
						"name": "惠水县"
					},
					{
						"code": "522732",
						"name": "三都水族自治县"
					}

				]

			}

		]

	},
	{
		"code": "530000",
		"name": "云南省",
		"cityList": [{
				"code": "530100",
				"name": "昆明市",
				"areaList": [{
						"code": "530102",
						"name": "五华区"
					},
					{
						"code": "530103",
						"name": "盘龙区"
					},
					{
						"code": "530111",
						"name": "官渡区"
					},
					{
						"code": "530112",
						"name": "西山区"
					},
					{
						"code": "530113",
						"name": "东川区"
					},
					{
						"code": "530114",
						"name": "呈贡区"
					},
					{
						"code": "530115",
						"name": "晋宁区"
					},
					{
						"code": "530124",
						"name": "富民县"
					},
					{
						"code": "530125",
						"name": "宜良县"
					},
					{
						"code": "530126",
						"name": "石林彝族自治县"
					},
					{
						"code": "530127",
						"name": "嵩明县"
					},
					{
						"code": "530128",
						"name": "禄劝彝族苗族自治县"
					},
					{
						"code": "530129",
						"name": "寻甸回族彝族自治县"
					},
					{
						"code": "530181",
						"name": "安宁市"
					}

				]

			},
			{
				"code": "530300",
				"name": "曲靖市",
				"areaList": [{
						"code": "530302",
						"name": "麒麟区"
					},
					{
						"code": "530303",
						"name": "沾益区"
					},
					{
						"code": "530321",
						"name": "马龙县"
					},
					{
						"code": "530322",
						"name": "陆良县"
					},
					{
						"code": "530323",
						"name": "师宗县"
					},
					{
						"code": "530324",
						"name": "罗平县"
					},
					{
						"code": "530325",
						"name": "富源县"
					},
					{
						"code": "530326",
						"name": "会泽县"
					},
					{
						"code": "530381",
						"name": "宣威市"
					}

				]

			},
			{
				"code": "530400",
				"name": "玉溪市",
				"areaList": [{
						"code": "530402",
						"name": "红塔区"
					},
					{
						"code": "530403",
						"name": "江川区"
					},
					{
						"code": "530422",
						"name": "澄江县"
					},
					{
						"code": "530423",
						"name": "通海县"
					},
					{
						"code": "530424",
						"name": "华宁县"
					},
					{
						"code": "530425",
						"name": "易门县"
					},
					{
						"code": "530426",
						"name": "峨山彝族自治县"
					},
					{
						"code": "530427",
						"name": "新平彝族傣族自治县"
					},
					{
						"code": "530428",
						"name": "元江哈尼族彝族傣族自治县"
					}

				]

			},
			{
				"code": "530500",
				"name": "保山市",
				"areaList": [{
						"code": "530502",
						"name": "隆阳区"
					},
					{
						"code": "530521",
						"name": "施甸县"
					},
					{
						"code": "530523",
						"name": "龙陵县"
					},
					{
						"code": "530524",
						"name": "昌宁县"
					},
					{
						"code": "530581",
						"name": "腾冲市"
					}

				]

			},
			{
				"code": "530600",
				"name": "昭通市",
				"areaList": [{
						"code": "530602",
						"name": "昭阳区"
					},
					{
						"code": "530621",
						"name": "鲁甸县"
					},
					{
						"code": "530622",
						"name": "巧家县"
					},
					{
						"code": "530623",
						"name": "盐津县"
					},
					{
						"code": "530624",
						"name": "大关县"
					},
					{
						"code": "530625",
						"name": "永善县"
					},
					{
						"code": "530626",
						"name": "绥江县"
					},
					{
						"code": "530627",
						"name": "镇雄县"
					},
					{
						"code": "530628",
						"name": "彝良县"
					},
					{
						"code": "530629",
						"name": "威信县"
					},
					{
						"code": "530630",
						"name": "水富县"
					}

				]

			},
			{
				"code": "530700",
				"name": "丽江市",
				"areaList": [{
						"code": "530702",
						"name": "古城区"
					},
					{
						"code": "530721",
						"name": "玉龙纳西族自治县"
					},
					{
						"code": "530722",
						"name": "永胜县"
					},
					{
						"code": "530723",
						"name": "华坪县"
					},
					{
						"code": "530724",
						"name": "宁蒗彝族自治县"
					}

				]

			},
			{
				"code": "530800",
				"name": "普洱市",
				"areaList": [{
						"code": "530802",
						"name": "思茅区"
					},
					{
						"code": "530821",
						"name": "宁洱哈尼族彝族自治县"
					},
					{
						"code": "530822",
						"name": "墨江哈尼族自治县"
					},
					{
						"code": "530823",
						"name": "景东彝族自治县"
					},
					{
						"code": "530824",
						"name": "景谷傣族彝族自治县"
					},
					{
						"code": "530825",
						"name": "镇沅彝族哈尼族拉祜族自治县"
					},
					{
						"code": "530826",
						"name": "江城哈尼族彝族自治县"
					},
					{
						"code": "530827",
						"name": "孟连傣族拉祜族佤族自治县"
					},
					{
						"code": "530828",
						"name": "澜沧拉祜族自治县"
					},
					{
						"code": "530829",
						"name": "西盟佤族自治县"
					}

				]

			},
			{
				"code": "530900",
				"name": "临沧市",
				"areaList": [{
						"code": "530902",
						"name": "临翔区"
					},
					{
						"code": "530921",
						"name": "凤庆县"
					},
					{
						"code": "530922",
						"name": "云县"
					},
					{
						"code": "530923",
						"name": "永德县"
					},
					{
						"code": "530924",
						"name": "镇康县"
					},
					{
						"code": "530925",
						"name": "双江拉祜族佤族布朗族傣族自治县"
					},
					{
						"code": "530926",
						"name": "耿马傣族佤族自治县"
					},
					{
						"code": "530927",
						"name": "沧源佤族自治县"
					}

				]

			},
			{
				"code": "532300",
				"name": "楚雄彝族自治州",
				"areaList": [{
						"code": "532301",
						"name": "楚雄市"
					},
					{
						"code": "532322",
						"name": "双柏县"
					},
					{
						"code": "532323",
						"name": "牟定县"
					},
					{
						"code": "532324",
						"name": "南华县"
					},
					{
						"code": "532325",
						"name": "姚安县"
					},
					{
						"code": "532326",
						"name": "大姚县"
					},
					{
						"code": "532327",
						"name": "永仁县"
					},
					{
						"code": "532328",
						"name": "元谋县"
					},
					{
						"code": "532329",
						"name": "武定县"
					},
					{
						"code": "532331",
						"name": "禄丰县"
					}

				]

			},
			{
				"code": "532500",
				"name": "红河哈尼族彝族自治州",
				"areaList": [{
						"code": "532501",
						"name": "个旧市"
					},
					{
						"code": "532502",
						"name": "开远市"
					},
					{
						"code": "532503",
						"name": "蒙自市"
					},
					{
						"code": "532504",
						"name": "弥勒市"
					},
					{
						"code": "532523",
						"name": "屏边苗族自治县"
					},
					{
						"code": "532524",
						"name": "建水县"
					},
					{
						"code": "532525",
						"name": "石屏县"
					},
					{
						"code": "532527",
						"name": "泸西县"
					},
					{
						"code": "532528",
						"name": "元阳县"
					},
					{
						"code": "532529",
						"name": "红河县"
					},
					{
						"code": "532530",
						"name": "金平苗族瑶族傣族自治县"
					},
					{
						"code": "532531",
						"name": "绿春县"
					},
					{
						"code": "532532",
						"name": "河口瑶族自治县"
					}

				]

			},
			{
				"code": "532600",
				"name": "文山壮族苗族自治州",
				"areaList": [{
						"code": "532601",
						"name": "文山市"
					},
					{
						"code": "532622",
						"name": "砚山县"
					},
					{
						"code": "532623",
						"name": "西畴县"
					},
					{
						"code": "532624",
						"name": "麻栗坡县"
					},
					{
						"code": "532625",
						"name": "马关县"
					},
					{
						"code": "532626",
						"name": "丘北县"
					},
					{
						"code": "532627",
						"name": "广南县"
					},
					{
						"code": "532628",
						"name": "富宁县"
					}

				]

			},
			{
				"code": "532800",
				"name": "西双版纳傣族自治州",
				"areaList": [{
						"code": "532801",
						"name": "景洪市"
					},
					{
						"code": "532822",
						"name": "勐海县"
					},
					{
						"code": "532823",
						"name": "勐腊县"
					}

				]

			},
			{
				"code": "532900",
				"name": "大理白族自治州",
				"areaList": [{
						"code": "532901",
						"name": "大理市"
					},
					{
						"code": "532922",
						"name": "漾濞彝族自治县"
					},
					{
						"code": "532923",
						"name": "祥云县"
					},
					{
						"code": "532924",
						"name": "宾川县"
					},
					{
						"code": "532925",
						"name": "弥渡县"
					},
					{
						"code": "532926",
						"name": "南涧彝族自治县"
					},
					{
						"code": "532927",
						"name": "巍山彝族回族自治县"
					},
					{
						"code": "532928",
						"name": "永平县"
					},
					{
						"code": "532929",
						"name": "云龙县"
					},
					{
						"code": "532930",
						"name": "洱源县"
					},
					{
						"code": "532931",
						"name": "剑川县"
					},
					{
						"code": "532932",
						"name": "鹤庆县"
					}

				]

			},
			{
				"code": "533100",
				"name": "德宏傣族景颇族自治州",
				"areaList": [{
						"code": "533102",
						"name": "瑞丽市"
					},
					{
						"code": "533103",
						"name": "芒市"
					},
					{
						"code": "533122",
						"name": "梁河县"
					},
					{
						"code": "533123",
						"name": "盈江县"
					},
					{
						"code": "533124",
						"name": "陇川县"
					}

				]

			},
			{
				"code": "533300",
				"name": "怒江傈僳族自治州",
				"areaList": [{
						"code": "533301",
						"name": "泸水市"
					},
					{
						"code": "533323",
						"name": "福贡县"
					},
					{
						"code": "533324",
						"name": "贡山独龙族怒族自治县"
					},
					{
						"code": "533325",
						"name": "兰坪白族普米族自治县"
					}

				]

			},
			{
				"code": "533400",
				"name": "迪庆藏族自治州",
				"areaList": [{
						"code": "533401",
						"name": "香格里拉市"
					},
					{
						"code": "533422",
						"name": "德钦县"
					},
					{
						"code": "533423",
						"name": "维西傈僳族自治县"
					}

				]

			}

		]

	},
	{
		"code": "540000",
		"name": "西藏自治区",
		"cityList": [{
				"code": "540100",
				"name": "拉萨市",
				"areaList": [{
						"code": "540102",
						"name": "城关区"
					},
					{
						"code": "540103",
						"name": "堆龙德庆区"
					},
					{
						"code": "540104",
						"name": "达孜区"
					},
					{
						"code": "540121",
						"name": "林周县"
					},
					{
						"code": "540122",
						"name": "当雄县"
					},
					{
						"code": "540123",
						"name": "尼木县"
					},
					{
						"code": "540124",
						"name": "曲水县"
					},
					{
						"code": "540127",
						"name": "墨竹工卡县"
					}

				]

			},
			{
				"code": "540200",
				"name": "日喀则市",
				"areaList": [{
						"code": "540202",
						"name": "桑珠孜区"
					},
					{
						"code": "540221",
						"name": "南木林县"
					},
					{
						"code": "540222",
						"name": "江孜县"
					},
					{
						"code": "540223",
						"name": "定日县"
					},
					{
						"code": "540224",
						"name": "萨迦县"
					},
					{
						"code": "540225",
						"name": "拉孜县"
					},
					{
						"code": "540226",
						"name": "昂仁县"
					},
					{
						"code": "540227",
						"name": "谢通门县"
					},
					{
						"code": "540228",
						"name": "白朗县"
					},
					{
						"code": "540229",
						"name": "仁布县"
					},
					{
						"code": "540230",
						"name": "康马县"
					},
					{
						"code": "540231",
						"name": "定结县"
					},
					{
						"code": "540232",
						"name": "仲巴县"
					},
					{
						"code": "540233",
						"name": "亚东县"
					},
					{
						"code": "540234",
						"name": "吉隆县"
					},
					{
						"code": "540235",
						"name": "聂拉木县"
					},
					{
						"code": "540236",
						"name": "萨嘎县"
					},
					{
						"code": "540237",
						"name": "岗巴县"
					}

				]

			},
			{
				"code": "540300",
				"name": "昌都市",
				"areaList": [{
						"code": "540302",
						"name": "卡若区"
					},
					{
						"code": "540321",
						"name": "江达县"
					},
					{
						"code": "540322",
						"name": "贡觉县"
					},
					{
						"code": "540323",
						"name": "类乌齐县"
					},
					{
						"code": "540324",
						"name": "丁青县"
					},
					{
						"code": "540325",
						"name": "察雅县"
					},
					{
						"code": "540326",
						"name": "八宿县"
					},
					{
						"code": "540327",
						"name": "左贡县"
					},
					{
						"code": "540328",
						"name": "芒康县"
					},
					{
						"code": "540329",
						"name": "洛隆县"
					},
					{
						"code": "540330",
						"name": "边坝县"
					}

				]

			},
			{
				"code": "540400",
				"name": "林芝市",
				"areaList": [{
						"code": "540402",
						"name": "巴宜区"
					},
					{
						"code": "540421",
						"name": "工布江达县"
					},
					{
						"code": "540422",
						"name": "米林县"
					},
					{
						"code": "540423",
						"name": "墨脱县"
					},
					{
						"code": "540424",
						"name": "波密县"
					},
					{
						"code": "540425",
						"name": "察隅县"
					},
					{
						"code": "540426",
						"name": "朗县"
					}

				]

			},
			{
				"code": "540500",
				"name": "山南市",
				"areaList": [{
						"code": "540502",
						"name": "乃东区"
					},
					{
						"code": "540521",
						"name": "扎囊县"
					},
					{
						"code": "540522",
						"name": "贡嘎县"
					},
					{
						"code": "540523",
						"name": "桑日县"
					},
					{
						"code": "540524",
						"name": "琼结县"
					},
					{
						"code": "540525",
						"name": "曲松县"
					},
					{
						"code": "540526",
						"name": "措美县"
					},
					{
						"code": "540527",
						"name": "洛扎县"
					},
					{
						"code": "540528",
						"name": "加查县"
					},
					{
						"code": "540529",
						"name": "隆子县"
					},
					{
						"code": "540530",
						"name": "错那县"
					},
					{
						"code": "540531",
						"name": "浪卡子县"
					}

				]

			},
			{
				"code": "540600",
				"name": "那曲市",
				"areaList": [{
						"code": "540602",
						"name": "色尼区"
					},
					{
						"code": "540621",
						"name": "嘉黎县"
					},
					{
						"code": "540622",
						"name": "比如县"
					},
					{
						"code": "540623",
						"name": "聂荣县"
					},
					{
						"code": "540624",
						"name": "安多县"
					},
					{
						"code": "540625",
						"name": "申扎县"
					},
					{
						"code": "540626",
						"name": "索县"
					},
					{
						"code": "540627",
						"name": "班戈县"
					},
					{
						"code": "540628",
						"name": "巴青县"
					},
					{
						"code": "540629",
						"name": "尼玛县"
					},
					{
						"code": "540630",
						"name": "双湖县"
					}

				]

			},
			{
				"code": "542500",
				"name": "阿里地区",
				"areaList": [{
						"code": "542521",
						"name": "普兰县"
					},
					{
						"code": "542522",
						"name": "札达县"
					},
					{
						"code": "542523",
						"name": "噶尔县"
					},
					{
						"code": "542524",
						"name": "日土县"
					},
					{
						"code": "542525",
						"name": "革吉县"
					},
					{
						"code": "542526",
						"name": "改则县"
					},
					{
						"code": "542527",
						"name": "措勤县"
					}

				]

			}

		]

	},
	{
		"code": "610000",
		"name": "陕西省",
		"cityList": [{
				"code": "610100",
				"name": "西安市",
				"areaList": [{
						"code": "610102",
						"name": "新城区"
					},
					{
						"code": "610103",
						"name": "碑林区"
					},
					{
						"code": "610104",
						"name": "莲湖区"
					},
					{
						"code": "610111",
						"name": "灞桥区"
					},
					{
						"code": "610112",
						"name": "未央区"
					},
					{
						"code": "610113",
						"name": "雁塔区"
					},
					{
						"code": "610114",
						"name": "阎良区"
					},
					{
						"code": "610115",
						"name": "临潼区"
					},
					{
						"code": "610116",
						"name": "长安区"
					},
					{
						"code": "610117",
						"name": "高陵区"
					},
					{
						"code": "610118",
						"name": "鄠邑区"
					},
					{
						"code": "610122",
						"name": "蓝田县"
					},
					{
						"code": "610124",
						"name": "周至县"
					}

				]

			},
			{
				"code": "610200",
				"name": "铜川市",
				"areaList": [{
						"code": "610202",
						"name": "王益区"
					},
					{
						"code": "610203",
						"name": "印台区"
					},
					{
						"code": "610204",
						"name": "耀州区"
					},
					{
						"code": "610222",
						"name": "宜君县"
					}

				]

			},
			{
				"code": "610300",
				"name": "宝鸡市",
				"areaList": [{
						"code": "610302",
						"name": "渭滨区"
					},
					{
						"code": "610303",
						"name": "金台区"
					},
					{
						"code": "610304",
						"name": "陈仓区"
					},
					{
						"code": "610322",
						"name": "凤翔县"
					},
					{
						"code": "610323",
						"name": "岐山县"
					},
					{
						"code": "610324",
						"name": "扶风县"
					},
					{
						"code": "610326",
						"name": "眉县"
					},
					{
						"code": "610327",
						"name": "陇县"
					},
					{
						"code": "610328",
						"name": "千阳县"
					},
					{
						"code": "610329",
						"name": "麟游县"
					},
					{
						"code": "610330",
						"name": "凤县"
					},
					{
						"code": "610331",
						"name": "太白县"
					}

				]

			},
			{
				"code": "610400",
				"name": "咸阳市",
				"areaList": [{
						"code": "610402",
						"name": "秦都区"
					},
					{
						"code": "610403",
						"name": "杨陵区"
					},
					{
						"code": "610404",
						"name": "渭城区"
					},
					{
						"code": "610422",
						"name": "三原县"
					},
					{
						"code": "610423",
						"name": "泾阳县"
					},
					{
						"code": "610424",
						"name": "乾县"
					},
					{
						"code": "610425",
						"name": "礼泉县"
					},
					{
						"code": "610426",
						"name": "永寿县"
					},
					{
						"code": "610427",
						"name": "彬县"
					},
					{
						"code": "610428",
						"name": "长武县"
					},
					{
						"code": "610429",
						"name": "旬邑县"
					},
					{
						"code": "610430",
						"name": "淳化县"
					},
					{
						"code": "610431",
						"name": "武功县"
					},
					{
						"code": "610481",
						"name": "兴平市"
					}

				]

			},
			{
				"code": "610500",
				"name": "渭南市",
				"areaList": [{
						"code": "610502",
						"name": "临渭区"
					},
					{
						"code": "610503",
						"name": "华州区"
					},
					{
						"code": "610522",
						"name": "潼关县"
					},
					{
						"code": "610523",
						"name": "大荔县"
					},
					{
						"code": "610524",
						"name": "合阳县"
					},
					{
						"code": "610525",
						"name": "澄城县"
					},
					{
						"code": "610526",
						"name": "蒲城县"
					},
					{
						"code": "610527",
						"name": "白水县"
					},
					{
						"code": "610528",
						"name": "富平县"
					},
					{
						"code": "610581",
						"name": "韩城市"
					},
					{
						"code": "610582",
						"name": "华阴市"
					}

				]

			},
			{
				"code": "610600",
				"name": "延安市",
				"areaList": [{
						"code": "610602",
						"name": "宝塔区"
					},
					{
						"code": "610603",
						"name": "安塞区"
					},
					{
						"code": "610621",
						"name": "延长县"
					},
					{
						"code": "610622",
						"name": "延川县"
					},
					{
						"code": "610623",
						"name": "子长县"
					},
					{
						"code": "610625",
						"name": "志丹县"
					},
					{
						"code": "610626",
						"name": "吴起县"
					},
					{
						"code": "610627",
						"name": "甘泉县"
					},
					{
						"code": "610628",
						"name": "富县"
					},
					{
						"code": "610629",
						"name": "洛川县"
					},
					{
						"code": "610630",
						"name": "宜川县"
					},
					{
						"code": "610631",
						"name": "黄龙县"
					},
					{
						"code": "610632",
						"name": "黄陵县"
					}

				]

			},
			{
				"code": "610700",
				"name": "汉中市",
				"areaList": [{
						"code": "610702",
						"name": "汉台区"
					},
					{
						"code": "610703",
						"name": "南郑区"
					},
					{
						"code": "610722",
						"name": "城固县"
					},
					{
						"code": "610723",
						"name": "洋县"
					},
					{
						"code": "610724",
						"name": "西乡县"
					},
					{
						"code": "610725",
						"name": "勉县"
					},
					{
						"code": "610726",
						"name": "宁强县"
					},
					{
						"code": "610727",
						"name": "略阳县"
					},
					{
						"code": "610728",
						"name": "镇巴县"
					},
					{
						"code": "610729",
						"name": "留坝县"
					},
					{
						"code": "610730",
						"name": "佛坪县"
					}

				]

			},
			{
				"code": "610800",
				"name": "榆林市",
				"areaList": [{
						"code": "610802",
						"name": "榆阳区"
					},
					{
						"code": "610803",
						"name": "横山区"
					},
					{
						"code": "610822",
						"name": "府谷县"
					},
					{
						"code": "610824",
						"name": "靖边县"
					},
					{
						"code": "610825",
						"name": "定边县"
					},
					{
						"code": "610826",
						"name": "绥德县"
					},
					{
						"code": "610827",
						"name": "米脂县"
					},
					{
						"code": "610828",
						"name": "佳县"
					},
					{
						"code": "610829",
						"name": "吴堡县"
					},
					{
						"code": "610830",
						"name": "清涧县"
					},
					{
						"code": "610831",
						"name": "子洲县"
					},
					{
						"code": "610881",
						"name": "神木市"
					}

				]

			},
			{
				"code": "610900",
				"name": "安康市",
				"areaList": [{
						"code": "610902",
						"name": "汉滨区"
					},
					{
						"code": "610921",
						"name": "汉阴县"
					},
					{
						"code": "610922",
						"name": "石泉县"
					},
					{
						"code": "610923",
						"name": "宁陕县"
					},
					{
						"code": "610924",
						"name": "紫阳县"
					},
					{
						"code": "610925",
						"name": "岚皋县"
					},
					{
						"code": "610926",
						"name": "平利县"
					},
					{
						"code": "610927",
						"name": "镇坪县"
					},
					{
						"code": "610928",
						"name": "旬阳县"
					},
					{
						"code": "610929",
						"name": "白河县"
					}

				]

			},
			{
				"code": "611000",
				"name": "商洛市",
				"areaList": [{
						"code": "611002",
						"name": "商州区"
					},
					{
						"code": "611021",
						"name": "洛南县"
					},
					{
						"code": "611022",
						"name": "丹凤县"
					},
					{
						"code": "611023",
						"name": "商南县"
					},
					{
						"code": "611024",
						"name": "山阳县"
					},
					{
						"code": "611025",
						"name": "镇安县"
					},
					{
						"code": "611026",
						"name": "柞水县"
					}

				]

			}

		]

	},
	{
		"code": "620000",
		"name": "甘肃省",
		"cityList": [{
				"code": "620100",
				"name": "兰州市",
				"areaList": [{
						"code": "620102",
						"name": "城关区"
					},
					{
						"code": "620103",
						"name": "七里河区"
					},
					{
						"code": "620104",
						"name": "西固区"
					},
					{
						"code": "620105",
						"name": "安宁区"
					},
					{
						"code": "620111",
						"name": "红古区"
					},
					{
						"code": "620121",
						"name": "永登县"
					},
					{
						"code": "620122",
						"name": "皋兰县"
					},
					{
						"code": "620123",
						"name": "榆中县"
					}

				]

			},
			{
				"code": "620200",
				"name": "嘉峪关市",
				"areaList": [

				]

			},
			{
				"code": "620300",
				"name": "金昌市",
				"areaList": [{
						"code": "620302",
						"name": "金川区"
					},
					{
						"code": "620321",
						"name": "永昌县"
					}

				]

			},
			{
				"code": "620400",
				"name": "白银市",
				"areaList": [{
						"code": "620402",
						"name": "白银区"
					},
					{
						"code": "620403",
						"name": "平川区"
					},
					{
						"code": "620421",
						"name": "靖远县"
					},
					{
						"code": "620422",
						"name": "会宁县"
					},
					{
						"code": "620423",
						"name": "景泰县"
					}

				]

			},
			{
				"code": "620500",
				"name": "天水市",
				"areaList": [{
						"code": "620502",
						"name": "秦州区"
					},
					{
						"code": "620503",
						"name": "麦积区"
					},
					{
						"code": "620521",
						"name": "清水县"
					},
					{
						"code": "620522",
						"name": "秦安县"
					},
					{
						"code": "620523",
						"name": "甘谷县"
					},
					{
						"code": "620524",
						"name": "武山县"
					},
					{
						"code": "620525",
						"name": "张家川回族自治县"
					}

				]

			},
			{
				"code": "620600",
				"name": "武威市",
				"areaList": [{
						"code": "620602",
						"name": "凉州区"
					},
					{
						"code": "620621",
						"name": "民勤县"
					},
					{
						"code": "620622",
						"name": "古浪县"
					},
					{
						"code": "620623",
						"name": "天祝藏族自治县"
					}

				]

			},
			{
				"code": "620700",
				"name": "张掖市",
				"areaList": [{
						"code": "620702",
						"name": "甘州区"
					},
					{
						"code": "620721",
						"name": "肃南裕固族自治县"
					},
					{
						"code": "620722",
						"name": "民乐县"
					},
					{
						"code": "620723",
						"name": "临泽县"
					},
					{
						"code": "620724",
						"name": "高台县"
					},
					{
						"code": "620725",
						"name": "山丹县"
					}

				]

			},
			{
				"code": "620800",
				"name": "平凉市",
				"areaList": [{
						"code": "620802",
						"name": "崆峒区"
					},
					{
						"code": "620821",
						"name": "泾川县"
					},
					{
						"code": "620822",
						"name": "灵台县"
					},
					{
						"code": "620823",
						"name": "崇信县"
					},
					{
						"code": "620824",
						"name": "华亭县"
					},
					{
						"code": "620825",
						"name": "庄浪县"
					},
					{
						"code": "620826",
						"name": "静宁县"
					}

				]

			},
			{
				"code": "620900",
				"name": "酒泉市",
				"areaList": [{
						"code": "620902",
						"name": "肃州区"
					},
					{
						"code": "620921",
						"name": "金塔县"
					},
					{
						"code": "620922",
						"name": "瓜州县"
					},
					{
						"code": "620923",
						"name": "肃北蒙古族自治县"
					},
					{
						"code": "620924",
						"name": "阿克塞哈萨克族自治县"
					},
					{
						"code": "620981",
						"name": "玉门市"
					},
					{
						"code": "620982",
						"name": "敦煌市"
					}

				]

			},
			{
				"code": "621000",
				"name": "庆阳市",
				"areaList": [{
						"code": "621002",
						"name": "西峰区"
					},
					{
						"code": "621021",
						"name": "庆城县"
					},
					{
						"code": "621022",
						"name": "环县"
					},
					{
						"code": "621023",
						"name": "华池县"
					},
					{
						"code": "621024",
						"name": "合水县"
					},
					{
						"code": "621025",
						"name": "正宁县"
					},
					{
						"code": "621026",
						"name": "宁县"
					},
					{
						"code": "621027",
						"name": "镇原县"
					}

				]

			},
			{
				"code": "621100",
				"name": "定西市",
				"areaList": [{
						"code": "621102",
						"name": "安定区"
					},
					{
						"code": "621121",
						"name": "通渭县"
					},
					{
						"code": "621122",
						"name": "陇西县"
					},
					{
						"code": "621123",
						"name": "渭源县"
					},
					{
						"code": "621124",
						"name": "临洮县"
					},
					{
						"code": "621125",
						"name": "漳县"
					},
					{
						"code": "621126",
						"name": "岷县"
					}

				]

			},
			{
				"code": "621200",
				"name": "陇南市",
				"areaList": [{
						"code": "621202",
						"name": "武都区"
					},
					{
						"code": "621221",
						"name": "成县"
					},
					{
						"code": "621222",
						"name": "文县"
					},
					{
						"code": "621223",
						"name": "宕昌县"
					},
					{
						"code": "621224",
						"name": "康县"
					},
					{
						"code": "621225",
						"name": "西和县"
					},
					{
						"code": "621226",
						"name": "礼县"
					},
					{
						"code": "621227",
						"name": "徽县"
					},
					{
						"code": "621228",
						"name": "两当县"
					}

				]

			},
			{
				"code": "622900",
				"name": "临夏回族自治州",
				"areaList": [{
						"code": "622901",
						"name": "临夏市"
					},
					{
						"code": "622921",
						"name": "临夏县"
					},
					{
						"code": "622922",
						"name": "康乐县"
					},
					{
						"code": "622923",
						"name": "永靖县"
					},
					{
						"code": "622924",
						"name": "广河县"
					},
					{
						"code": "622925",
						"name": "和政县"
					},
					{
						"code": "622926",
						"name": "东乡族自治县"
					},
					{
						"code": "622927",
						"name": "积石山保安族东乡族撒拉族自治县"
					}

				]

			},
			{
				"code": "623000",
				"name": "甘南藏族自治州",
				"areaList": [{
						"code": "623001",
						"name": "合作市"
					},
					{
						"code": "623021",
						"name": "临潭县"
					},
					{
						"code": "623022",
						"name": "卓尼县"
					},
					{
						"code": "623023",
						"name": "舟曲县"
					},
					{
						"code": "623024",
						"name": "迭部县"
					},
					{
						"code": "623025",
						"name": "玛曲县"
					},
					{
						"code": "623026",
						"name": "碌曲县"
					},
					{
						"code": "623027",
						"name": "夏河县"
					}

				]

			}

		]

	},
	{
		"code": "630000",
		"name": "青海省",
		"cityList": [{
				"code": "630100",
				"name": "西宁市",
				"areaList": [{
						"code": "630102",
						"name": "城东区"
					},
					{
						"code": "630103",
						"name": "城中区"
					},
					{
						"code": "630104",
						"name": "城西区"
					},
					{
						"code": "630105",
						"name": "城北区"
					},
					{
						"code": "630121",
						"name": "大通回族土族自治县"
					},
					{
						"code": "630122",
						"name": "湟中县"
					},
					{
						"code": "630123",
						"name": "湟源县"
					}

				]

			},
			{
				"code": "630200",
				"name": "海东市",
				"areaList": [{
						"code": "630202",
						"name": "乐都区"
					},
					{
						"code": "630203",
						"name": "平安区"
					},
					{
						"code": "630222",
						"name": "民和回族土族自治县"
					},
					{
						"code": "630223",
						"name": "互助土族自治县"
					},
					{
						"code": "630224",
						"name": "化隆回族自治县"
					},
					{
						"code": "630225",
						"name": "循化撒拉族自治县"
					}

				]

			},
			{
				"code": "632200",
				"name": "海北藏族自治州",
				"areaList": [{
						"code": "632221",
						"name": "门源回族自治县"
					},
					{
						"code": "632222",
						"name": "祁连县"
					},
					{
						"code": "632223",
						"name": "海晏县"
					},
					{
						"code": "632224",
						"name": "刚察县"
					}

				]

			},
			{
				"code": "632300",
				"name": "黄南藏族自治州",
				"areaList": [{
						"code": "632321",
						"name": "同仁县"
					},
					{
						"code": "632322",
						"name": "尖扎县"
					},
					{
						"code": "632323",
						"name": "泽库县"
					},
					{
						"code": "632324",
						"name": "河南蒙古族自治县"
					}

				]

			},
			{
				"code": "632500",
				"name": "海南藏族自治州",
				"areaList": [{
						"code": "632521",
						"name": "共和县"
					},
					{
						"code": "632522",
						"name": "同德县"
					},
					{
						"code": "632523",
						"name": "贵德县"
					},
					{
						"code": "632524",
						"name": "兴海县"
					},
					{
						"code": "632525",
						"name": "贵南县"
					}

				]

			},
			{
				"code": "632600",
				"name": "果洛藏族自治州",
				"areaList": [{
						"code": "632621",
						"name": "玛沁县"
					},
					{
						"code": "632622",
						"name": "班玛县"
					},
					{
						"code": "632623",
						"name": "甘德县"
					},
					{
						"code": "632624",
						"name": "达日县"
					},
					{
						"code": "632625",
						"name": "久治县"
					},
					{
						"code": "632626",
						"name": "玛多县"
					}

				]

			},
			{
				"code": "632700",
				"name": "玉树藏族自治州",
				"areaList": [{
						"code": "632701",
						"name": "玉树市"
					},
					{
						"code": "632722",
						"name": "杂多县"
					},
					{
						"code": "632723",
						"name": "称多县"
					},
					{
						"code": "632724",
						"name": "治多县"
					},
					{
						"code": "632725",
						"name": "囊谦县"
					},
					{
						"code": "632726",
						"name": "曲麻莱县"
					}

				]

			},
			{
				"code": "632800",
				"name": "海西蒙古族藏族自治州",
				"areaList": [{
						"code": "632801",
						"name": "格尔木市"
					},
					{
						"code": "632802",
						"name": "德令哈市"
					},
					{
						"code": "632821",
						"name": "乌兰县"
					},
					{
						"code": "632822",
						"name": "都兰县"
					},
					{
						"code": "632823",
						"name": "天峻县"
					}

				]

			}

		]

	},
	{
		"code": "640000",
		"name": "宁夏回族自治区",
		"cityList": [{
				"code": "640100",
				"name": "银川市",
				"areaList": [{
						"code": "640104",
						"name": "兴庆区"
					},
					{
						"code": "640105",
						"name": "西夏区"
					},
					{
						"code": "640106",
						"name": "金凤区"
					},
					{
						"code": "640121",
						"name": "永宁县"
					},
					{
						"code": "640122",
						"name": "贺兰县"
					},
					{
						"code": "640181",
						"name": "灵武市"
					}

				]

			},
			{
				"code": "640200",
				"name": "石嘴山市",
				"areaList": [{
						"code": "640202",
						"name": "大武口区"
					},
					{
						"code": "640205",
						"name": "惠农区"
					},
					{
						"code": "640221",
						"name": "平罗县"
					}

				]

			},
			{
				"code": "640300",
				"name": "吴忠市",
				"areaList": [{
						"code": "640302",
						"name": "利通区"
					},
					{
						"code": "640303",
						"name": "红寺堡区"
					},
					{
						"code": "640323",
						"name": "盐池县"
					},
					{
						"code": "640324",
						"name": "同心县"
					},
					{
						"code": "640381",
						"name": "青铜峡市"
					}

				]

			},
			{
				"code": "640400",
				"name": "固原市",
				"areaList": [{
						"code": "640402",
						"name": "原州区"
					},
					{
						"code": "640422",
						"name": "西吉县"
					},
					{
						"code": "640423",
						"name": "隆德县"
					},
					{
						"code": "640424",
						"name": "泾源县"
					},
					{
						"code": "640425",
						"name": "彭阳县"
					}

				]

			},
			{
				"code": "640500",
				"name": "中卫市",
				"areaList": [{
						"code": "640502",
						"name": "沙坡头区"
					},
					{
						"code": "640521",
						"name": "中宁县"
					},
					{
						"code": "640522",
						"name": "海原县"
					}

				]

			}

		]

	},
	{
		"code": "650000",
		"name": "新疆维吾尔自治区",
		"cityList": [{
				"code": "650100",
				"name": "乌鲁木齐市",
				"areaList": [{
						"code": "650102",
						"name": "天山区"
					},
					{
						"code": "650103",
						"name": "沙依巴克区"
					},
					{
						"code": "650104",
						"name": "新市区"
					},
					{
						"code": "650105",
						"name": "水磨沟区"
					},
					{
						"code": "650106",
						"name": "头屯河区"
					},
					{
						"code": "650107",
						"name": "达坂城区"
					},
					{
						"code": "650109",
						"name": "米东区"
					},
					{
						"code": "650121",
						"name": "乌鲁木齐县"
					}

				]

			},
			{
				"code": "650200",
				"name": "克拉玛依市",
				"areaList": [{
						"code": "650202",
						"name": "独山子区"
					},
					{
						"code": "650203",
						"name": "克拉玛依区"
					},
					{
						"code": "650204",
						"name": "白碱滩区"
					},
					{
						"code": "650205",
						"name": "乌尔禾区"
					}

				]

			},
			{
				"code": "650400",
				"name": "吐鲁番市",
				"areaList": [{
						"code": "650402",
						"name": "高昌区"
					},
					{
						"code": "650421",
						"name": "鄯善县"
					},
					{
						"code": "650422",
						"name": "托克逊县"
					}

				]

			},
			{
				"code": "650500",
				"name": "哈密市",
				"areaList": [{
						"code": "650502",
						"name": "伊州区"
					},
					{
						"code": "650521",
						"name": "巴里坤哈萨克自治县"
					},
					{
						"code": "650522",
						"name": "伊吾县"
					}

				]

			},
			{
				"code": "652300",
				"name": "昌吉回族自治州",
				"areaList": [{
						"code": "652301",
						"name": "昌吉市"
					},
					{
						"code": "652302",
						"name": "阜康市"
					},
					{
						"code": "652323",
						"name": "呼图壁县"
					},
					{
						"code": "652324",
						"name": "玛纳斯县"
					},
					{
						"code": "652325",
						"name": "奇台县"
					},
					{
						"code": "652327",
						"name": "吉木萨尔县"
					},
					{
						"code": "652328",
						"name": "木垒哈萨克自治县"
					}

				]

			},
			{
				"code": "652700",
				"name": "博尔塔拉蒙古自治州",
				"areaList": [{
						"code": "652701",
						"name": "博乐市"
					},
					{
						"code": "652702",
						"name": "阿拉山口市"
					},
					{
						"code": "652722",
						"name": "精河县"
					},
					{
						"code": "652723",
						"name": "温泉县"
					}

				]

			},
			{
				"code": "652800",
				"name": "巴音郭楞蒙古自治州",
				"areaList": [{
						"code": "652801",
						"name": "库尔勒市"
					},
					{
						"code": "652822",
						"name": "轮台县"
					},
					{
						"code": "652823",
						"name": "尉犁县"
					},
					{
						"code": "652824",
						"name": "若羌县"
					},
					{
						"code": "652825",
						"name": "且末县"
					},
					{
						"code": "652826",
						"name": "焉耆回族自治县"
					},
					{
						"code": "652827",
						"name": "和静县"
					},
					{
						"code": "652828",
						"name": "和硕县"
					},
					{
						"code": "652829",
						"name": "博湖县"
					}

				]

			},
			{
				"code": "652900",
				"name": "阿克苏地区",
				"areaList": [{
						"code": "652901",
						"name": "阿克苏市"
					},
					{
						"code": "652922",
						"name": "温宿县"
					},
					{
						"code": "652923",
						"name": "库车县"
					},
					{
						"code": "652924",
						"name": "沙雅县"
					},
					{
						"code": "652925",
						"name": "新和县"
					},
					{
						"code": "652926",
						"name": "拜城县"
					},
					{
						"code": "652927",
						"name": "乌什县"
					},
					{
						"code": "652928",
						"name": "阿瓦提县"
					},
					{
						"code": "652929",
						"name": "柯坪县"
					}

				]

			},
			{
				"code": "653000",
				"name": "克孜勒苏柯尔克孜自治州",
				"areaList": [{
						"code": "653001",
						"name": "阿图什市"
					},
					{
						"code": "653022",
						"name": "阿克陶县"
					},
					{
						"code": "653023",
						"name": "阿合奇县"
					},
					{
						"code": "653024",
						"name": "乌恰县"
					}

				]

			},
			{
				"code": "653100",
				"name": "喀什地区",
				"areaList": [{
						"code": "653101",
						"name": "喀什市"
					},
					{
						"code": "653121",
						"name": "疏附县"
					},
					{
						"code": "653122",
						"name": "疏勒县"
					},
					{
						"code": "653123",
						"name": "英吉沙县"
					},
					{
						"code": "653124",
						"name": "泽普县"
					},
					{
						"code": "653125",
						"name": "莎车县"
					},
					{
						"code": "653126",
						"name": "叶城县"
					},
					{
						"code": "653127",
						"name": "麦盖提县"
					},
					{
						"code": "653128",
						"name": "岳普湖县"
					},
					{
						"code": "653129",
						"name": "伽师县"
					},
					{
						"code": "653130",
						"name": "巴楚县"
					},
					{
						"code": "653131",
						"name": "塔什库尔干塔吉克自治县"
					}

				]

			},
			{
				"code": "653200",
				"name": "和田地区",
				"areaList": [{
						"code": "653201",
						"name": "和田市"
					},
					{
						"code": "653221",
						"name": "和田县"
					},
					{
						"code": "653222",
						"name": "墨玉县"
					},
					{
						"code": "653223",
						"name": "皮山县"
					},
					{
						"code": "653224",
						"name": "洛浦县"
					},
					{
						"code": "653225",
						"name": "策勒县"
					},
					{
						"code": "653226",
						"name": "于田县"
					},
					{
						"code": "653227",
						"name": "民丰县"
					}

				]

			},
			{
				"code": "654000",
				"name": "伊犁哈萨克自治州",
				"areaList": [{
						"code": "654002",
						"name": "伊宁市"
					},
					{
						"code": "654003",
						"name": "奎屯市"
					},
					{
						"code": "654004",
						"name": "霍尔果斯市"
					},
					{
						"code": "654021",
						"name": "伊宁县"
					},
					{
						"code": "654022",
						"name": "察布查尔锡伯自治县"
					},
					{
						"code": "654023",
						"name": "霍城县"
					},
					{
						"code": "654024",
						"name": "巩留县"
					},
					{
						"code": "654025",
						"name": "新源县"
					},
					{
						"code": "654026",
						"name": "昭苏县"
					},
					{
						"code": "654027",
						"name": "特克斯县"
					},
					{
						"code": "654028",
						"name": "尼勒克县"
					}

				]

			},
			{
				"code": "654200",
				"name": "塔城地区",
				"areaList": [{
						"code": "654201",
						"name": "塔城市"
					},
					{
						"code": "654202",
						"name": "乌苏市"
					},
					{
						"code": "654221",
						"name": "额敏县"
					},
					{
						"code": "654223",
						"name": "沙湾县"
					},
					{
						"code": "654224",
						"name": "托里县"
					},
					{
						"code": "654225",
						"name": "裕民县"
					},
					{
						"code": "654226",
						"name": "和布克赛尔蒙古自治县"
					}

				]

			},
			{
				"code": "654300",
				"name": "阿勒泰地区",
				"areaList": [{
						"code": "654301",
						"name": "阿勒泰市"
					},
					{
						"code": "654321",
						"name": "布尔津县"
					},
					{
						"code": "654322",
						"name": "富蕴县"
					},
					{
						"code": "654323",
						"name": "福海县"
					},
					{
						"code": "654324",
						"name": "哈巴河县"
					},
					{
						"code": "654325",
						"name": "青河县"
					},
					{
						"code": "654326",
						"name": "吉木乃县"
					}

				]

			}

		]

	},
	{
		"code": "710000",
		"name": "台湾省",
		"cityList": [{
				"code": "710000",
				"name": "台湾省",
				"areaList": [{
						"code": "710000",
						"name": "台湾省"
					}

				]

			}

		]

	},
	{
		"code": "810000",
		"name": "香港特别行政区",
		"cityList": [{
				"code": "810000",
				"name": "香港特别行政区",
				"areaList": [{
						"code": "810000",
						"name": "香港特别行政区"
					}

				]

			}

		]

	},
	{
		"code": "820000",
		"name": "澳门特别行政区",
		"cityList": [{
				"code": "820000",
				"name": "澳门特别行政区",
				"areaList": [{
						"code": "820000",
						"name": "澳门特别行政区"
					}

				]

			}

		]

	}
]